export const Gradients = {
  headerBg: 'linear-gradient(180deg, #ffffff 0%, #f5f5f5 100%)',
  yellow: 'linear-gradient(to right, rgba(254, 134, 56, 1) 1%,rgba(255, 197, 75, 1) 100%)',
  orange: 'linear-gradient(to right, rgba(252, 70, 66, 1) 1%,rgba(255, 139, 56, 1) 100%)',
  red: 'linear-gradient(to right, rgba(245, 25, 105, 1) 1%,rgba(254, 77, 70, 1) 100%)',
  black: 'linear-gradient(to right, #000 1%, #333 100%)',
  grey: 'linear-gradient(to right, #54545E 1%, #EBECF0 100%)',
  lightGrey: 'linear-gradient(to right, #eeeeee 1%, #fafafa 100%)',
  green: 'linear-gradient(to right, green 1%, #a5d6a7 100%)',
  blue: 'linear-gradient(to right, #34BACC 1%, #C2EAF0 100%)',
  notPink: 'linear-gradient(to right, rgba(202, 0, 179, 1) 1%,rgba(254, 17, 97, 1) 100%)',
  notPurple: 'linear-gradient(to right, rgba(99, 50, 255, 1) 1%,rgba(209, 0, 169, 1) 100%)',
};
